import React, { useEffect, useState } from 'react';
import Navbar from '../navigation/Navbar';
import style from '../css/Address.module.css';
import axios from 'axios';
import { FaHome, FaTrash } from 'react-icons/fa';
import HeaderBar from '../components/HeaderBar';

function Address() {
	const [formData, setFormData] = useState({
		street: '',
		pincode: '',
		city: '',
		town: '',
		address_type: '',
	});
	const [message, setMessage] = useState('');
	const [addresses, setAddresses] = useState([]);

	const user = JSON.parse(localStorage.getItem('user'));

	useEffect(() => {
		if (user?.id) {
			fetchAddresses();
		}
	}, []);

	const fetchAddresses = async () => {
		try {
			const res = await axios.post(
				'https://hometech-repairs.in/customerDB/get_address.php',
				{ profile_id: user.id }
			);
			if (res.data.status) {
				setAddresses(res.data.data);
			}
		} catch (error) {
			console.error('Error fetching addresses:', error);
		}
	};

	const handleChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		if (!user?.id) {
			setMessage('User not logged in');
			return;
		}

		try {
			const response = await axios.post(
				'https://hometech-repairs.in/customerDB/upload_address.php',
				{ ...formData, profile_id: user.id }
			);

			if (response.data.status) {
				setMessage('Address saved successfully!');
				setFormData({
					street: '',
					pincode: '',
					city: '',
					town: '',
					address_type: '',
				});
				fetchAddresses();
			} else {
				setMessage(response.data.msg || 'Failed to save address');
			}
		} catch (error) {
			setMessage('Something went wrong. Please try again.');
		}
	};

	const handleDelete = async (id) => {
		try {
			const res = await axios.post(
				'https://hometech-repairs.in/customerDB/delete_address.php',
				{ id }
			);
			if (res.data.status) {
				setMessage('Address deleted');
				fetchAddresses();
			} else {
				setMessage('Delete failed');
			}
		} catch (error) {
			setMessage('Something went wrong');
		}
	};

	return (
		<div>
			<HeaderBar
				text={'Your Address'}
				icon={<FaHome color="black" size={20} />}
				navi="/dashboard"
			/>

			<div className={style.profileContainer}>
				<h4 className={style.heading}>Add New Address</h4>

				<form onSubmit={handleSubmit} className={style.form}>
					<input
						type="text"
						name="street"
						placeholder="Full Street Address"
						value={formData.street}
						onChange={handleChange}
						className={style.input}
						required
					/>
					<input
						type="text"
						name="town"
						placeholder="Town"
						value={formData.town}
						onChange={handleChange}
						className={style.input}
						required
					/>

					<select
						name="city"
						value={formData.city}
						onChange={handleChange}
						className={style.input}
						required
					>
						<option value="">Select City</option>
						<option value="Bangalore">Bangalore</option>
						<option value="Dhanbad">Dhanbad</option>
					</select>

					<input
						type="text"
						name="pincode"
						placeholder="Pincode"
						value={formData.pincode}
						onChange={handleChange}
						className={style.input}
						required
					/>
					<select
						name="address_type"
						value={formData.address_type}
						onChange={handleChange}
						className={style.input}
						required
					>
						<option value="">Select Address Type</option>
						<option value="Home">Home</option>
						<option value="Office">Office</option>
						<option value="Appartment">Appartment</option>
						<option value="Other">Other</option>
					</select>

					<button type="submit" className={style.button}>
						Save Address
					</button>
				</form>

				{message && <p className={style.message}>{message}</p>}

				<div className={style.addressList}>
					{addresses.map((addr) => (
						<div key={addr.id} className={style.addressBox}>
							<div className={style.addressHeader}>
								<p>
									<strong>{addr.address_type}</strong>
								</p>
								<button
									onClick={() => handleDelete(addr.id)}
									className={style.deleteBtn}
								>
									<FaTrash size={15} color="orangered" />
								</button>
							</div>
							<p>
								{addr.street}, {addr.town}, {addr.city} - {addr.pincode}
							</p>
						</div>
					))}
				</div>
			</div>
		</div>
	);
}

export default Address;
